import { UserRoundCheckIcon } from 'wisestep-base';

import { FilterSetValueProps } from '../models';

import RecruiterSuggestions from './RecruiterSuggestions';
import WsAccordion from './WsAccordion';

const RecruitersFilter = ({
  name,
  title,
  defaultValue,
  showAccordionIcon,
  onSelectMultipleValues,
}: FilterSetValueProps) => (
  <WsAccordion
    title={title ?? 'Posted By Recruiter'}
    startIcon={showAccordionIcon ? <UserRoundCheckIcon /> : null}
  >
    <RecruiterSuggestions
      name={name}
      multiple={true}
      requireRecruiter={false}
      defaultValue={defaultValue ?? []}
      onSelectMultipleValues={onSelectMultipleValues}
    />
  </WsAccordion>
);

export default RecruitersFilter;
